import React from "react";
import { BeneficiaryDetailsContainer } from "../../../containers";

const BeneficiaryDetails = (props) => {
  return <BeneficiaryDetailsContainer {...props} />;
};

export default BeneficiaryDetails;
